export const WIDGET_WIDTH = 360
export const WIDGET_COMPACT_HEIGHT = 256
export const WIDGET_EXPANDED_HEIGHT = 450
export const WIDGET_DEFAULT_TOP_OFFSET = 16
export const WIDGET_DEFAULT_RIGHT_INSET = 34
